import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {defaultCharacterLengthLimit, maxCharactersValidator} from '../validatorFunctions';


@Directive({
  selector: '[gtMaxCharactersValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: MaxCharactersValidatorDirective, multi: true}]
})
export class MaxCharactersValidatorDirective implements Validator {
  @Input('gtMaxCharactersValidator') maxCharacters: number;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('errorMessage') msg: string;

  validate(control: AbstractControl): {[key: string]: any} | null {
    return maxCharactersValidator(this.maxCharacters
       ? this.maxCharacters
       : defaultCharacterLengthLimit,
       this.msg)(control);
  }
}
